export const STATUS_COLORS: Record<string, { bg: string; color: string }> = {
    onboarded: { bg: '#22c55e', color: '#ffffff' },
    passed: { bg: '#ffeeee', color: '#df666a' },
    rejected: { bg: '#ffeeee', color: '#df666a' },
    'deal ongoing': { bg: '#e1ffe1', color: '#49a71b' },
    'deal running': { bg: '#e1ffe1', color: '#49a71b' },
    new: { bg: '#dbeafe', color: '#2563eb' },
    qualified: { bg: '#dbeafe', color: '#2563eb' },
};

export type SortKey =
    | 'orgName'
    | 'leadStatus'
    | 'relationshipStatus'
    | 'revenue'
    | 'ebitdaPct'
    | 'existingDebt'
    | 'equityRaised'
    | 'investors'
    | 'state'
    | 'similarityScore';
export type SortDir = 'asc' | 'desc';

export const COLUMNS = [
    { key: 'orgName', label: 'Entity', sortable: true, width: '203px', numeric: false },
    { key: 'similarityScore', label: 'Similarity Score', sortable: true, width: '112px', numeric: true },
    { key: 'leadStatus', label: 'Lead Status', sortable: true, width: '120px', numeric: false },
    { key: 'relationshipStatus', label: 'Relationship Status', sortable: true, width: '154px', numeric: false },
    { key: 'revenue', label: 'Revenue', sortable: true, width: '140px', numeric: true },
    { key: 'ebitdaPct', label: 'EBITDA %', sortable: true, width: '90px', numeric: true },
    { key: 'existingDebt', label: 'Existing Debt', sortable: true, width: '121px', numeric: true },
    { key: 'investors', label: 'Top Investors', sortable: true, width: '157px', numeric: false },
    { key: 'equityRaised', label: 'Equity Raised', sortable: true, width: '145px', numeric: true },
    { key: 'state', label: 'State', sortable: true, width: '160px', numeric: false },
] as const;
